import axios from './axios'
// import qs from "qs";

function service(endpoint) {
    function me() {
        return axios.get(`${endpoint}/me`).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        me,
    }
}

export default service
